const TZ = 'America/Sao_Paulo';

export const diaSP = (iso: string) =>
  new Intl.DateTimeFormat('sv-SE', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit' })
    .format(new Date(iso));

export const horaSP = (iso: string) =>
  new Intl.DateTimeFormat('pt-BR', { timeZone: TZ, hour: '2-digit', minute: '2-digit' }).format(
    new Date(iso),
  );

export const numeroDoDia = (iso: string) => Number(diaSP(iso).slice(8));

export const mesCurto = (iso: string) =>
  new Intl.DateTimeFormat('pt-BR', { timeZone: TZ, month: 'short' })
    .format(new Date(iso))
    .replace('.', '')
    .toUpperCase();

export const diaDaSemana = (iso: string) => {
  const texto = new Intl.DateTimeFormat('pt-BR', { timeZone: TZ, weekday: 'long' }).format(
    new Date(iso),
  );
  return texto.charAt(0).toUpperCase() + texto.slice(1);
};

export const dataPorExtenso = (iso: string) =>
  new Intl.DateTimeFormat('pt-BR', {
    timeZone: TZ,
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(new Date(iso));

/**
 * "Hoje", "Amanha", "daqui a 3 dias", "ha 2 dias" — contado em dias de
 * calendario de Sao Paulo, nao em intervalo de 24h. Um culto que comeca
 * as 21h de hoje nao pode virar "amanha" so porque faltam 25 horas.
 */
export function quandoEmPalavras(iso: string, agora = new Date()): string {
  const hoje = diaSP(agora.toISOString());
  const dia = diaSP(iso);
  const emDias = Math.round(
    (Date.parse(`${dia}T12:00:00Z`) - Date.parse(`${hoje}T12:00:00Z`)) / 86400000,
  );

  if (emDias === 0) return 'Hoje';
  if (emDias === 1) return 'Amanha';
  if (emDias === -1) return 'Ontem';
  if (emDias > 1) return `daqui a ${emDias} dias`;
  return `ha ${Math.abs(emDias)} dias`;
}

export const iniciais = (nome: string) =>
  nome
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((p) => p.charAt(0))
    .join('')
    .toUpperCase();
